import { Link } from 'react-router-dom';

import { Page, Button, AddIcon } from '@occc-app/design-system';
import { CampaignsTableContainer } from '@occc-app/routes/Campaign/CampaignListPage/components/CampaignsTableContainer';
import { useIsUserPermittedTo, Feature } from '@occc/utils-access-control';

import { messages } from './messages';

const CampaignsPage = () => {
  const isUserPermittedToCreateCampaign = useIsUserPermittedTo(Feature.CAMPAIGN_CREATE);

  return (
    <Page
      browserTabTitle={messages.title}
      pageHeaderProps={{ title: messages.title }}
      actions={
        isUserPermittedToCreateCampaign ? (
          <Button
            color='secondary'
            variant='contained'
            component={Link}
            to='/campaigns/create'
            startIcon={<AddIcon />}
            role='button'
          >
            create new campaign
          </Button>
        ) : null
      }
    >
      <CampaignsTableContainer />
    </Page>
  );
};

export default CampaignsPage;
